"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStruct = void 0;
var superstruct_1 = require("superstruct");
var ZephyrTypesConfig_1 = require("../constants/ZephyrTypesConfig");
function isStruct(value, struct, name) {
    if (value === undefined)
        return false;
    var error = (0, superstruct_1.validate)(value, struct)[0];
    if (!error)
        return true;
    var valueJson = JSON.stringify(value, null, 4);
    ZephyrTypesConfig_1.ZephyrTypesConfig.logError(Error("Invalid ".concat(name, "\n").concat(error.message, "\n").concat(valueJson)));
    return false;
}
exports.isStruct = isStruct;
